/* global ZAGFramework */

class HeaderOlb {
  constructor() {
    this.headerOlb();
  }
  headerOlb() {
    document.querySelector('.header-olb input#user_id').addEventListener('focus', function (evt) {
      evt.currentTarget.setAttribute('placeholder', '');
    });
    document.querySelector('.header-olb input#user_id').addEventListener('blur', function (evt) {
        if (evt.currentTarget.value == '') {
            evt.currentTarget.setAttribute('placeholder', 'Username');
        }
    });
    document.querySelector('.header-olb input#password').addEventListener('focus', function (evt) {
        evt.currentTarget.setAttribute('placeholder', '');
    });
    document.querySelector('.header-olb input#password').addEventListener('blur', function (evt) {
        if (evt.currentTarget.value == '') {
            evt.currentTarget.setAttribute('placeholder', 'Password');
        }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.header-olb')) {
    const headerOlb = new HeaderOlb();
  }
})